export enum ModalConstant {
    createWorkSpace = "CreateWorkSpaceModal",
    deleteWorkSpace = "DeleteWorkSpaceModal",
    deleteApplication = "DeleteApplicationModal",
    deleteEntity = "DeleteEntityModal",
    authConfig = "AuthConfigModal",
    newMember = "NewMemberModal",
    accountCreated = "AccountCreatedModal",
    // viewUserDetailsModal = "ViewUserDetailsModal",
    // notificationModal = "NotificationModal",
    // confirmationModal = "ConfirmationModal",
    // updateUserModal = "UpdateUserModal",
    // leavingPageModal = "LeavingPageModal",
    // addRoleModal = "AddRoleModal",
    // updateRoleModal = "UpdateRoleModal",
    // addProjectModal = "AddProjectModal",
    // updateProjectModal = "UpdateProjectModal",
}
